import Vue from 'vue'

export default {
	SET_MULTI_EDIT_DATA (state, {field, value}) {
		Vue.set(state, field, value)
	},
	SELECT_ID (state, {id, type, license_plate}) {
		Vue.set(state.selected_ids, `#${id}`, {
			type,
			license_plate
		})
	},
	DESELECT_ID (state, id) {
		Vue.delete(state.selected_ids, id);
	}
}
